import {
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  isWithinInterval,
  subMonths,
  subWeeks,
} from 'date-fns'

export type TimeGroup =
  | 'This Week'
  | 'Last Week'
  | 'This Month'
  | 'Last Month'
  | 'Older'

export function getTimeGroup(
  dateString: string,
  referenceDate: Date = new Date()
): TimeGroup {
  const itemDate = new Date(dateString)

  // Define week boundaries (Sunday to Saturday)
  const thisWeekStart = startOfWeek(referenceDate, { weekStartsOn: 0 })
  const thisWeekEnd = endOfWeek(referenceDate, { weekStartsOn: 0 })

  const lastWeekStart = startOfWeek(subWeeks(referenceDate, 1), {
    weekStartsOn: 0,
  })
  const lastWeekEnd = endOfWeek(subWeeks(referenceDate, 1), { weekStartsOn: 0 })

  const thisMonthStart = startOfMonth(referenceDate)
  const thisMonthEnd = endOfMonth(referenceDate)

  const lastMonthStart = startOfMonth(subMonths(referenceDate, 1))
  const lastMonthEnd = endOfMonth(subMonths(referenceDate, 1))

  // Check in priority order
  if (isWithinInterval(itemDate, { start: thisWeekStart, end: thisWeekEnd })) {
    return 'This Week'
  }
  if (isWithinInterval(itemDate, { start: lastWeekStart, end: lastWeekEnd })) {
    return 'Last Week'
  }
  if (
    isWithinInterval(itemDate, { start: thisMonthStart, end: thisMonthEnd })
  ) {
    return 'This Month'
  }
  if (
    isWithinInterval(itemDate, { start: lastMonthStart, end: lastMonthEnd })
  ) {
    return 'Last Month'
  }
  return 'Older'
}
